module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('ul', {
    staticClass: "unstyled-list ui-topnav"
  }, _vm._l((_vm.botones), function(bot, index) {
    return _c('li', {
      key: 'toplist' + index,
      staticClass: "animated rotateIn"
    }, [_c('button', {
      staticClass: "circ-topnav hvr-grow",
      class: (_vm.contenido === (index + 1) ? 'topnav-active' : '') + ' ' + ('dura_' + index),
      attrs: {
        "id": 'bot-slide-' + index,
        "aria-label": 'Botón ' + (index + 1) + (bot.visto ? ' Visto' : ' No visto')
      },
      on: {
        "click": function($event) {
          _vm.botClick(index)
        }
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "checkBot"
    }, [(bot.visto) ? _c('image-app', {
      staticClass: "animated bounceIn",
      attrs: {
        "imaSize": 20,
        "imaSrc": "logos-icons/ok-bullet",
        "imaAlt": ""
      }
    }) : _vm._e()], 1)])
  }))])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "mt-3": ""
    }
  }, [_c('div', {
    staticClass: "unstyled-focus",
    attrs: {
      "tabindex": "0",
      "id": "contenidos",
      "aria-label": 'Contenido boton ' + _vm.contenido
    }
  }), _vm._v(" "), _vm._l((_vm.botones), function(item, index) {
    return (_vm.contenido === (index + 1)) ? _c('div', {
      key: 'slide-cont' + index
    }, [_vm._t('cont-' + index)], 2) : _vm._e()
  }), _vm._v(" "), (!_vm.finContenidos) ? _c('button', {
    attrs: {
      "aria-label": "Volver a la lista anterior"
    },
    on: {
      "click": function($event) {
        _vm.backMenu()
      }
    }
  }) : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f0edb34","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/TopNavigation.vue
// module id = 1041
// module chunks = 1